//credit to @Bill Criswell for this filter
import moment from "moment";
import Vue from "vue";

Vue.filter('truncate', function (text, stop, clamp) {
    if (text != null) {
        return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
    }
})

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('ddd, D MMM YYYY')
    }
});

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('ddd, D MMM HH:mm')
    }
});

export default function(){}